import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { OPERATOR_PROFILE_KEY } from '../operator/useGetProfile'

type DeleteUserPayload = {
  userId: string
}

export function useDeleteUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ userId }: DeleteUserPayload) => {
      await apiClient.delete(`/int/v3/users/${userId}`)
    },
    onSuccess: (_data, { userId }) => {
      queryClient.invalidateQueries({ queryKey: [OPERATOR_PROFILE_KEY, userId] })
    },
  })
}
